import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { isNotNil } from '@sigma/sigma-utils';

@Injectable({ providedIn: 'root' })
export class PolicyService {
  constructor(private http: HttpClient) {}

  checkPolicy(municipality: any, firstName: string, lastName: string, token: string): Observable<HttpResponse<void>> {
    let headers = new HttpHeaders();
    headers = headers.set('token', token);
    let params = new HttpParams();
    params = params.set('municipality', municipality ?? '');
    params = params.set('firstName', firstName ?? '');
    params = params.set('lastName', lastName ?? '');
    return this.http
      .post<void>(
        SERVER_API_URL + 'api/public/check-policy',
        {},
        {
          observe: 'response',
          headers,
          params,
        },
      )
      .pipe(
        tap(res => {
          const auth: string | null = res.headers.get('Authorization');
          if (auth != null) {
            sessionStorage.setItem('authenticationToken', auth.replace('Bearer ', ''));
          }
        }),
      );
  }
}
